export default __webpack_public_path__ + "static/media/eye-solid.c1c13bce.svg";